export default __webpack_public_path__ + "0de52eca9e54623af86012a83445a160.svg";